var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 0.333496H1.99984C1.2665 0.333496 0.666504 0.933496 0.666504 1.66683V12.3335C0.666504 13.0668 1.2665 13.6668 1.99984 13.6668H9.99984C10.7332 13.6668 11.3332 13.0668 11.3332 12.3335V4.3335L7.33317 0.333496ZM1.99984 12.3335V1.66683H6.6665V4.3335H9.99984V12.3335H1.99984ZM5.33317 11.6668H6.6665V11.0002H7.33317C7.69984 11.0002 7.99984 10.7002 7.99984 10.3335V8.3335C7.99984 7.96683 7.69984 7.66683 7.33317 7.66683H5.33317V7.00016H7.99984V5.66683H6.6665V5.00016H5.33317V5.66683H4.6665C4.29984 5.66683 3.99984 5.96683 3.99984 6.3335V8.3335C3.99984 8.70016 4.29984 9.00016 4.6665 9.00016H6.6665V9.66683H3.99984V11.0002H5.33317V11.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteMoney);
export default __webpack_public_path__ + "static/media/noteMoney.77b3d22e0f64f1730272518e9ed03bbb.svg";
export { ForwardRef as ReactComponent };